(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardSettingEditCtrl', DashboardSettingEditCtrl);

    DashboardSettingEditCtrl.$inject = [
        '$scope',
        '$routeParams',
        '$q',
        'DashboardSettingsService',
        'EntityTemplatesService',
        'LastUpdatedService',
        'NavigationAidService',
        'DialogService',
        'UnsavedChangesService',
        'ChilliUserProfileService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService'];

    function DashboardSettingEditCtrl(
        $scope,
        $routeParams,
        $q,
        DashboardSettingsService,
        EntityTemplatesService,
        LastUpdatedService,
        NavigationAidService,
        DialogService,
        UnsavedChangesService,
        ChilliUserProfileService,
        ObjectSaveErrorHandlerService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.dashboardSetting = newDashboardSetting();
        vm.availablePanelSizes = ['Full', 'Half'];
        vm.availableEntityTemplates = [];
        vm.clearConfigurationField = clearConfigurationField;
        vm.saveDashboardSetting = saveDashboardSetting;
        vm.deleteDashboardSetting = deleteDashboardSetting;
        vm.close = close;
        vm.loading = true;
        vm.notFound = false;
        vm.permissionDenied = false;
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'dashboardSettingIsNew', {
                get: function () { return !($routeParams.id && $routeParams.id !== 'new'); }
                });
        Object.defineProperty(vm, 'lastUpdatedLabel', {
            get: function () { return LastUpdatedService.getLabel(vm.dashboardSetting); }
        });

        activate();

        function activate() {
            updateViewTitle();

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadDashboardSetting,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });
        }

        function loadDashboardSetting() {
            var loadPromises = [];
            if (!vm.dashboardSettingIsNew) {
                loadPromises.push(DashboardSettingsService.get($routeParams.id).then(getDashboardSettingOk, getDashboardSettingError));
            } else {
                loadPromises.push($q.when(newDashboardSetting()).then(getDashboardSettingOk, getDashboardSettingError));
            }

            loadPromises.push(loadEntityTemplates());

            return $q.all(loadPromises)
                .then(function () {
                    updateViewTitle();
                });

            function getDashboardSettingOk(data) {
                vm.dashboardSetting = data;

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.dashboardSetting',
                    saveFunction: saveDashboardSetting,
                    unsavedItemName: 'Dashboard Panel'
                });
            }

            function getDashboardSettingError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching Dashboard Panel', response);
                }
            }
        }

        function newDashboardSetting() {
            return {
                Size: 'Full',
                Configuration: { ListPageSize: 10 },
                Type: 'Entities'
            };
        }

        function clearConfigurationField() {
            if (!angular.isUndefined(vm.dashboardSetting.EntityTemplateId)) {
                delete vm.dashboardSetting.EntityTemplateId;
            }
        }

        function loadEntityTemplates() {
            return EntityTemplatesService.query()
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                vm.availableEntityTemplates = _.sortBy(data.EntityTemplates, function (entityTemplate) { return entityTemplate.Name; });
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching Entity Templates', response);
            }
        }

        /**
         * Save the dashboard panel
         *
         * @returns {Promise} A promise that resolves once saving is finished.
         */
        function saveDashboardSetting() {
            var promise = null;

            if (!_.isNil(vm.addDashboardSettingForm.$invalid) && vm.addDashboardSettingForm.$invalid) {
                promise = DialogService.messageList('Error saving dashboard panel', null, vm.addDashboardSettingForm.$error)
                            .then(function () {
                                return $q.reject();
                            });
            } else {
                promise = DashboardSettingsService.save(vm.dashboardSetting)
                    .then(saveDashboardSettingOk)
                    .catch(saveDashboardSettingError);
            }

            return promise;

            function saveDashboardSettingOk(response) {
                if (vm.dashboardSettingIsNew) {
                    UnsavedChangesService.dirty = false;
                    NavigationAidService.replacePage('dashboardsettings/' + response.Id);
                } else {
                    vm.dashboardSetting = response;
                    vm.addDashboardSettingForm.$setPristine();
                    updateViewTitle();

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.dashboardSetting',
                        saveFunction: saveDashboardSetting,
                        unsavedItemName: 'Dashboard Panel'
                    });
                }
            }

            function saveDashboardSettingError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.dashboardSetting,
                    'Dashboard Panel',
                    vm.saveDashboardSetting,
                    function () {
                        return DashboardSettingsService.get($routeParams.id);
                    });
            }
        }

        function deleteDashboardSetting() {
            if ($routeParams.id && $routeParams.id !== 'new') {
                DialogService.confirm('Delete the Dashboard Panel?', 'Delete Dashboard Panel')
                    .then(deleteOk);
            }

            function deleteOk() {
                DashboardSettingsService.remove($routeParams.id)
                        .then(deleteDashboardSettingOk)
                        .catch(deleteDashboardSettingError);

                    function deleteDashboardSettingOk(success) {
                        NavigationAidService.goBack();
                    }

                    function deleteDashboardSettingError(response) {
                        DialogService.error('Error deleting Dashboard Panel', response);
                    }
                }
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = 'Dashboard Panel';

            if (!_.isNil($routeParams.id) && $routeParams.id !== '') {
                if ($routeParams.id === 'new') {
                    title = 'Add ' + title;
                }
            }

            if (!_.isNil(vm.dashboardSetting) &&
                !_.isNil(vm.dashboardSetting.EntityTemplateId) &&
                !_.isNil(vm.availableEntityTemplates) &&
                vm.availableEntityTemplates.length > 0) {
                var selectedEntityTemplate = _.find(vm.availableEntityTemplates, function (entityTemplate) { return entityTemplate.Id === vm.dashboardSetting.EntityTemplateId; });

                if (!_.isNil(selectedEntityTemplate) && !_.isNil(selectedEntityTemplate.Name) && selectedEntityTemplate.Name !== '') {
                    title += ' - ' + selectedEntityTemplate.Name;
                }
            }

            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();
